// A booking page is opened with either the group id ("91000042") or the display
// booking id the app generates ("2026_10_ACRM_50"), whose last "_" segment is the
// group id. get_ezp_booking_by_id only accepts the numeric group id.
//
//   groupId  digits string, or null when there is no ref (a brand-new booking)
//   invalid  true when a ref was given but no group id can be read from it
//            (e.g. "GSM-BK-1042"). Callers must NOT treat that as "new booking".
export const parseBookingRef = (ref) => {
  const s = ref == null ? "" : String(ref).trim();
  if (!s) return { groupId: null, invalid: false };
  if (/^\d+$/.test(s)) return { groupId: s, invalid: false };
  const last = s.split("_").pop();
  if (s.includes("_") && /^\d+$/.test(last)) return { groupId: last, invalid: false };
  return { groupId: null, invalid: true };
};
